// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .react-flow__node-toolbar {
    position: absolute;
    top: -40px;
    left: 0;
}

.react-flow__node-toolbar .components-toolbar {
    height: 30px !important;
    min-height: 20px;
}

.react-flow__node-toolbar .components-toolbar > div {
    min-width: 30px;
}

.react-flow__node-toolbar button.components-button.components-toolbar__control.has-icon {
    min-width: 30px !important;
    height: 30px !important;
} */
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/toolbar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;GAkBG","sourcesContent":["/* .react-flow__node-toolbar {\n    position: absolute;\n    top: -40px;\n    left: 0;\n}\n\n.react-flow__node-toolbar .components-toolbar {\n    height: 30px !important;\n    min-height: 20px;\n}\n\n.react-flow__node-toolbar .components-toolbar > div {\n    min-width: 30px;\n}\n\n.react-flow__node-toolbar button.components-button.components-toolbar__control.has-icon {\n    min-width: 30px !important;\n    height: 30px !important;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
